import { Injector } from "@angular/core";
import { TreeNodeMeddraLevel } from "./TreeNodeMeddraLevel";
import { MeddraTerm } from "../../../Data/MeddraData/MeddraTerm";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { TreeNodePTItem } from "./TreeNodePTItem";
import { MeddraLevel } from '../../../MeddraEnum';
import { MeddraNode } from "../MeddraNode";
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";
import { SectionService } from "../../../../service/section-service/section-service";

export class TreeNodePTLevel extends TreeNodeMeddraLevel {


    constructor(injector: Injector, items: any[]|undefined, parent: BaseNode|undefined) {
        super(injector, items, EntityEnum.pt, parent);
    }

    override addChild(item: any): MeddraNode | null {
        const node = new TreeNodePTItem(this.ioc!,
            new MeddraTerm(new FieldDefinition(this.ioc!).ptFields, item), this);
        return this.addItem(item, node);
    }

    override addChildren(items: any[]): void {
        let newChild: BaseNode|undefined = undefined;
        items.forEach(item => {
            let lastAddedChildren = this.addItem(item, new TreeNodePTItem(this.ioc!,
                new MeddraTerm(new FieldDefinition(this.ioc!).ptFields, item), this));
                if (newChild == undefined) {
                    newChild = lastAddedChildren;
                }
        })
        if (newChild) {
            this.ioc!.get(SectionService).selectMeddraNode(newChild);
        }
    }

    override removeChildren(items: any[]): void {
        items.forEach(item => {
            this.removeItem(item, new TreeNodePTItem(this.ioc!,
                new MeddraTerm(new FieldDefinition(this.ioc!).ptFields, item),this));
        });
    }

    override getCriteriaFields(): string[] {
        return ['code', 'name'];
    }

    override getPlaceHolderTemplate(): string{
        return "Search Preferred Terms for the selected MedDRA version available in the XEVMPD";
    }
}